import $ from "jquery";
import React from "react";
import ReactGA from 'react-ga4';
import SessionManager from "../routes/SessionManager";
import AppConfig from '../config/AppConfig';
import Router from "../components/Router";
import { createContext, useState } from "react";
export let Context = createContext();

const App = () => {

    const history = require("history").createBrowserHistory();
    ReactGA.initialize(AppConfig.getGoogleAnalyticsId());
    history.listen((location, action) => {
        let page = window.location.pathname.toLocaleUpperCase().replace(/-/g, ' ');
        ReactGA.send({ hitType: "pageview", page: 'SiteSupt OnDemand ' + page.replace(/\//g, '» '), title: page.replace(/\//g, '') });
    });

    let sessionManager = new SessionManager();
    let user1 = sessionManager.readCookie('user', false);
    const [user, setUser] = useState(user1);

    let updateUser = (newUserVal) => {
        sessionManager.storeCookie('user', newUserVal);
        setUser(newUserVal);
    }
    $.ajaxPrefilter(function (options, _, jqXHR) {
        if (!options.url.indexOf('authenticate')) {
            sessionManager.readCookie('user');
        }
    });

    $.ajaxSetup({
        headers: { "x-api-key": "OIE3m9hJUI3egDNNU2mj1anJYK7FOJHm9J2DsznY" },
        complete: function (...args) {
            if (args[0].readyState === 4 && args[0].responseJSON && args[0].responseJSON.status && args[0].responseJSON.status.code === 201 && (args[0].responseJSON.status.message === 'Token Expired or Invalid Token' || args[0].responseJSON.status.message === "INVALID_TOKEN")) {
                sessionManager.removeCookie('user');
                window.location = window.location.origin + "/";
            }
        }
    });
    
    return (
        <Context.Provider value={{ user, updateUser }}>
            <Router />
        </Context.Provider>
    );
}

export default App;